export const SEARCH_QUERY_PARAM = 'search';

export function getSearchQuery(searchParams: URLSearchParams): string {
  return searchParams.get(SEARCH_QUERY_PARAM) ?? '';
}

export function withSearchQuery(path: string, search: string): string {
  if (!search) return path;

  const [pathAndQuery, hash] = path.split('#', 2);
  const separator = pathAndQuery.includes('?') ? '&' : '?';
  const query = new URLSearchParams({ [SEARCH_QUERY_PARAM]: search }).toString();

  return `${pathAndQuery}${separator}${query}${hash ? `#${hash}` : ''}`;
}
